// Utilities to parse and format tolerant numeric input for React forms

const DECIMAL_REGEX = /[\d.,-]/g;

export function sanitizeNumericString(raw, { allowNegative = false } = {}) {
  if (raw == null) return '';
  let s = String(raw);
  if (!allowNegative) {
    s = s.replace(/-/g, '');
  } else {
    // Keep only the first minus sign at the beginning
    s = s.replace(/(?!^)-/g, '');
    if (s.includes('-') && !s.startsWith('-')) {
      s = s.replace(/-/g, '');
    }
  }
  // Keep digits, commas and dots; drop other chars except leading minus handled above
  s = (allowNegative && s.startsWith('-') ? '-' : '') + s.replace(/^-/, '').match(DECIMAL_REGEX)?.join('')?.replace(/-/g, '') ?? '';
  return s;
}

export function parseNumericInput(raw, { mode = 'decimal', allowNegative = false } = {}) {
  if (raw == null) return { number: null, clamped: null };
  const sanitized = sanitizeNumericString(String(raw), { allowNegative });
  if (sanitized === '' || sanitized === '-' || sanitized === '.' || sanitized === '-.') {
    return { number: null, clamped: null };
  }
  // Normalize decimal separator by removing thousands separators
  const normalized = sanitized.replace(/,/g, '');
  const n = mode === 'integer' ? parseInt(normalized, 10) : parseFloat(normalized);
  if (!Number.isFinite(n)) return { number: null, clamped: null };
  const number = mode === 'integer' ? Math.trunc(n) : n;
  return { number, clamped: number };
}

export function clampNumber(value, { min, max } = {}) {
  if (value == null || !Number.isFinite(value)) return value;
  let v = value;
  if (typeof min === 'number') v = Math.max(min, v);
  if (typeof max === 'number') v = Math.min(max, v);
  return v;
}

export function formatNumericValue(value, { mode = 'decimal', decimals, prefix = '', suffix = '' } = {}) {
  if (value == null || !Number.isFinite(value)) return '';
  let v = value;
  if (typeof decimals === 'number') {
    const factor = Math.pow(10, decimals);
    v = Math.round(v * factor) / factor;
  }
  const str = mode === 'integer' ? String(Math.trunc(v)) : String(v);
  return `${prefix}${str}${suffix}`;
}


